<ng-container *ngIf="vbPurlinAdditional">
    <div fxLayout="row" fxLayoutAlign="flex-start center">
        <label class="mb-0 text-nowrap">{{translate.getLng('PURLIN')}} {{translate.getLng('MATERIAL')}}</label>
        <mat-select class="ml-3 w-25 border-bottom border-dark" [(ngModel)]="cboPurlinMat"
            (ngModelChange)="getHangerBolt()">
            <mat-option *ngFor="let m of aPurlinMat" [value]="m.data">
                {{m.label}}
            </mat-option>
        </mat-select>
    </div>
    <div fxLayout="row" fxLayoutAlign="flex-start center" class="mt-3 mb-2">
        <label class="mb-0 text-nowrap">{{translate.getLng('STOSCH')}} {{translate.getLng('SCREW_LENGTH')}}</label>
        <mat-select class="text-right w-25 ml-1 border-bottom border-dark" [(ngModel)]="cboHangerBoltScrewLength">
            <mat-option *ngFor="let l of cboHangerBoltData" [value]="l.length">
                {{l.length}}
            </mat-option>
        </mat-select>
        <span class="sen-fs10">{{translate.getLng('UNIT_MM')}}</span>
    </div>
</ng-container>
<ng-container *ngIf="trapezCrisCross">
    <hr class="border-white my-1">
    <h4 class="d-flex align-items-center pt-2">{{translate.getLng('TRAPEZ_SHEET')}} &nbsp;<a
            href="/assets/help/trapez_parameter.pdf" target="_blank">
            <mat-icon matSuffix class="sen-cursor-pointer" color="primary">
                info</mat-icon>
        </a>
    </h4>
    <div fxLayout="row wrap" fxLayoutAlign="flex-start center" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxFlex="48%">
            <label class="mb-0">{{translate.getLng('MATERIAL')}}</label>
            <mat-select class="ml-3 border-bottom border-dark" [(ngModel)]="cboTrapezSheetMat">
                <mat-option *ngFor="let m of aTrapezSheetMat" [value]="m.data">
                    {{m.label}}
                </mat-option>
            </mat-select>
        </div>
        <div fxLayout="row" fxLayoutAlign="flex-start center" fxFlex="48%">
            <label class="mb-0 text-nowrap">{{translate.getLng('TRAPEZ_BTTM_CHRD')}}</label>
            <input fxFlex="20%" [(ngModel)]="nsBottomChord" class="mx-2 border-bottom border-dark text-right"
                type="number" min="0" max="400" matInput>
            <span class="sen-fs10">{{translate.getLng('UNIT_MM')}}</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="flex-start center" fxFlex="48%" class="mt-3">
            <label class="mb-0 text-nowrap">{{translate.getLng('TRAPEZ_TP_CHRD')}}</label>
            <input fxFlex="20%" [(ngModel)]="nsTopChord" type="number" class="mx-2 border-bottom border-dark text-right"
                min="0" max="200" matInput>
            <span class="sen-fs10">{{translate.getLng('UNIT_MM')}}</span>
        </div>
        <div fxLayout="row" fxLayoutAlign="flex-start center" fxFlex="48%" class="mt-3">
            <label class="mb-0 text-nowrap">{{translate.getLng('TRAPEZ_PRFL_HGHT')}}</label>
            <input fxFlex="20%" [(ngModel)]="nsHeight" type="number" class="mx-2 border-bottom border-dark text-right"
                min="0" max="200" matInput>
            <span class="sen-fs10">{{translate.getLng('UNIT_MM')}}</span>
        </div>
    </div>
    <hr class="border-white">
    <div fxLayout="row" fxLayoutAlign="flex-start center">
        <label class="mb-0 text-nowrap">{{translate.getLng('CLTT_SIZE')}}</label>
        <input fxFlex="10%" [(ngModel)]="nsSize" type="number" class="w-25 mx-2 border-bottom border-dark text-right"
            min="20" max="60" matInput>
        <span class="sen-fs10">{{translate.getLng('UNIT_MM')}}</span>
    </div>
</ng-container>
<hr class="border-white">
<sen-app-beam-distance-control [beamType]="translate.getLng('PURLIN_DISTANCE')" (emitbSuccess)="setbSuccess($event)">
</sen-app-beam-distance-control>